import React from "react";
import cover from "../image/cover-front.png";
import logo from "../image/SVG/logo.svg";

interface TabHomeProps {
    selectTabRead: any;
}

const TabHome = (props: TabHomeProps) => {
    //Displays the title and the 'read' link

    return (
        <div className="home">
            <div className="homeCover">
                <img src={cover} alt="Poems for Androids cover" />
            </div>

            <div className="menu">
                <div className="title">
                    <img src={logo} alt="Poems for Androids" />
                    <h3>octav codrea</h3>
                </div>

                <div className="links">
                    <button
                        className="read"
                        onClick={() => props.selectTabRead()}
                    >
                        read
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TabHome;
